import {Definition} from "@components/dialog/definition/Definition";
import {IAlert} from "@components/core/Alerts";
import {Alert} from "@components/interface/Alert";
import React, {CSSProperties, useContext, useState} from "react";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {THEME} from "@components/core/theme";
import {AdSense} from "@components/interface/AdSense";
import {selectDialog} from "@redux/selectors/dialog";
import {connect} from "react-redux";
import {update as updateDialog} from "@redux/slices/dialog";
import {Update} from "@redux/slices/base";
import {Game} from "@game/game";
import {AdContext} from "../../AdProvider";

const styles: Record<string, CSSProperties> = {
    button: {
        fontSize: "large",
        margin: 2,
        padding: 4
    },
    definition: {
        fontSize: "small",
        minHeight: 0,
        overflowY: "auto"
    },
    score: {
        display: "flex"
    },
    scores: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0
    },
    scoreLine: {
        ...THEME.text,
        display: "flex",
        fontSize: "large",
        justifyContent: "space-between"
    },
    total: {
        flexGrow: 1,
        fontSize: 42,
        textAlign: "end"
    }
};
let shownRemoveAdverts = false;

interface IScoreAlert {
    alert: IAlert
    game: Game
    onClose: () => boolean
    updateDialog: Update
}
function ScoreAlert({alert, game, onClose, updateDialog}: IScoreAlert) {
    const adContext = useContext(AdContext);
    const handleClose = () => {
        interface IAdBreak {
            breakFormat: string
            breakName: string
            breakStatus: string
            breakType: string
        }

        if (onClose() && adContext.ready) {
            adContext.adBreak({
                type: "pause",
                name: "AfterScoreAlert",
                adBreakDone: (adBreak: IAdBreak) => {
                    if (adBreak.breakStatus === "viewed" && ! game.userPlayer?.anonymous && !shownRemoveAdverts) {
                        shownRemoveAdverts = true;
                        updateDialog({update: {name: "removeAdverts"}});
                    }
                }
            })
        }
    };
    const handleLoginClick = () => {
        onClose();
        updateDialog({update: {name: "authenticate"}});
    };
    const position = alert.data.region_id != null && alert.data.tile_id != null
        ? game.size.getTilePosition({regionId: alert.data.region_id, tileId: alert.data.tile_id})
        : undefined;
    const handleVisitClick = position ? () => {
        onClose();
        updateDialog({update: {name: "definition", data: {word: alert.data.word, position: {x: position.x, y: position.y}}}});
    } : undefined;
    const buttons = [
        ...(handleVisitClick ? [<button onClick={handleVisitClick} style={styles.button}>Visit</button>] : []),
        ...(game.userPlayer?.anonymous ? [<button onClick={handleLoginClick} style={styles.button}>
            <LocalisedTypography content="ButtonLoginForHighScores"/>
        </button>] : [])
    ];

    return (
        <Alert buttons={buttons} onClose={handleClose}>
            <div style={styles.score}>
                <div style={styles.scores}>
                    <div style={styles.scoreLine}>
                        <LocalisedTypography content={"ScoreWordScore"}/>
                        <span style={THEME.text}>{alert.data.wordScore}</span>
                    </div>
                    <div style={styles.scoreLine}>
                        <LocalisedTypography content={"ScoreWordCount"}/>
                        <span style={THEME.text}>{alert.data.count}</span>
                    </div>
                    <div style={styles.scoreLine}>
                        <LocalisedTypography content={"ScorePlacedScore"}/>
                        <span style={THEME.text}>{alert.data.placedScore}</span>
                    </div>
                </div>
                <div style={styles.total}>
                    <span style={THEME.text}>{alert.data.score}</span>
                    
                </div>
            </div>
            <div style={styles.definition}>
                <Definition word={alert.data.word}/>
            </div>
        </Alert>
    );
}

const mapStateToProps = () => ({
});
const connected = connect(mapStateToProps, {
    updateDialog
})(ScoreAlert);
export {connected as ScoreAlert}
